import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateExpedienteVinculadoRequest extends CreateKeyValueRequest {
  public idExpedienteVinculado!: number
  public idExpediente!: number
}
